import type { FaireProductEntity } from "../../entity_types/product";

export const p_p8zf35esgw: FaireProductEntity = {
  token: "p_p8zf35esgw",
  type: "product",
  name: '5.6" Plum blossom jasper howling wolf w/ Info Card H311',
  brandToken: "b_yrt8x5m6m6",
  brandName: "The 7 Directions",
  imageUrl:
    "https://cdn.faire.com/fastly/d20a3c28a5c180c3f48e7936fd39ff724f4431f5026f9ac796bdc01bea2359b6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/873a90eeacdf3bf81e1c98c2bdd98c063de6ed96c4ac213a2837b4cd455ac6c0.jpeg",
    "https://cdn.faire.com/fastly/cf40e10325e731afd70d260e2e89214aa0fa82adf57ee4d7d1087bf4ecd3a888.jpeg",
    "https://cdn.faire.com/fastly/957281f4b8d4647b169f010b86a3656826c2fbea151f3076b4166af2507c45f7.jpeg",
    "https://cdn.faire.com/fastly/dd361c8dede38bd5320062881833bc4f5a8772cea54debf675e778e6816bc1be.jpeg",
    "https://cdn.faire.com/fastly/976222454bb739fecca35d7d4a4b739e7d1f800e8966c7ed48d2b256183b1c23.jpeg",
  ],
  priceDollars: 60.97,
  description:
    '5.6" Plum blossom jasper howling wolf w/ Info Card H311\n\n🔹 This is the exact set you will receive\n\nComes with 1 crystal meaning card',
  tags: [],
  msrpDollars: 121.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:05.785Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
